import React from 'react';

import { bool, string, node, shape } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './ExplainInput.scss';

/**
 * @deprecated
 */
export default class ExplainInput extends BaseComponent {
  render() {
    const { invalid, children, id, style, className } = this.props;

    const classes = ['explain-input', className, invalid && 'invalid'];
    const classNames = ClassNames(classes);

    return (
      <div className={classNames} style={style} id={id}>
        {children}
      </div>
    );
  }
}

ExplainInput.propTypes = {
  invalid: bool,
  children: node,
  className: string,
  id: string,
  style: shape({})
};

ExplainInput.defaultProps = {
  invalid: false,
  className: undefined,
  id: undefined,
  style: {}
};
